<template>
  <router-view />
</template>
<script>
import { defineComponent } from "vue";

import log from "electron-log";

if (import.meta.env.QUASAR_MODE === "electron") {
  log.errorHandler.startCatching({
    onError: (options) => {
      console.error("Generic handler, options:", options);
    },
  });
  Object.assign(console, log.functions);
}

export default defineComponent({
  name: "App",
  setup() {},
});
</script>
